import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { APPLICANT_ADD_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class AddApplicantRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = [];

  url = APPLICANT_ADD_URL;

  constructor(payLoad) {
    super();
    this.body = payLoad;
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
